import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import RoomAbnormal from '../components/report/RoomReportAbnormally';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ roomAbnormallyReport, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <RoomAbnormal
          intl={intl}
          dispatch={dispatch}
          roomReport={roomAbnormallyReport}
          loading={loading}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/RoomAbnormal.js